import {
  Fragment,
  createRef,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Button, Card, Col, Row, Spinner, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  cpf_cnpj_mask,
  getAllData,
  getCaminhoes,
  getDateInitMonth,
  getTableColumns,
  telefone_mask,
  updateTable,
  updateTableNew,
  valorMoeda,
} from "../../services/Servicos";
import ScrollbarLeft from "../scrollbars/ScrollbarLeft";
import HeadTable from "../table/head/HeadRow";
import {
  filtroDinamicoArrays,
  getColorOfFilial,
  getColorOfStatusBool,
  getErrorMessage,
  removerDadosDuplicados,
  telefoneMask,
} from "../../services/helpers";
import ModalCriarFreteiro from "../modal/ModalCriarFreteiro";
import BodyRow from "../table/body/BodyRow";
import ModalLancamento from "./ModalLancamento";
import ModalCancelamento from "../frota/manutencao/ModalCancelamento";
import ModalEdicao from "../frota/manutencao/ModalEdicao";
import ModalError from "../modal/ModalError";
import ExportToExcel from "../exportToExcel/ExportToExcel";
import ModalErrorPretty from "../modal/ModalErrorPretty";
import { SocketContext } from "../../context/SocketContext";

const tableRef = createRef();
const tbodyRef = createRef();

export default function MensagensClientes() {
  return (
    <Fragment>
      <Card className="card-user">
        <ListarDados />
      </Card>
    </Fragment>
  );
}

function ListarDados() {
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(true);
  const [indexList, setIndexList] = useState(10);
  const [filteredTable, setFilteredTable] = useState(false);
  const [filters, setFilters] = useState([]);
  const [lancarModal, setLancarModal] = useState({
    flag: false,
  });
  const [dataFiltro, setDataFiltro] = useState("");
  const socket = useContext(SocketContext);

  const [headList, setHead] = useState([]);

  const getColumns = async () => {
    const header = await getTableColumns("NotificacoesWhatsappCliente");
    setHead([
      "index",
      "admin",
      "emissao",
      ...Object.keys(header.data)
        .filter((key) => key !== "empresas_id")
        .filter((key) => key !== "created_at")
        .filter((key) => key !== "updated_at")
        .filter((key) => key !== "id_wpp_message")
        .filter((key) => key !== "emissao"),
    ]);
  };

  const getDados = async (data_inicial, data_final) => {
    setLoading(true);

    const [anoI, mesI, diaI] = data_inicial.split("-");
    const dataI = new Date(anoI, Number(mesI) - 1, diaI);
    const [anoF, mesF, diaF] = data_final.split("-");
    const dataF = new Date(anoF, Number(mesF) - 1, diaF);
    let objCons = {
      data_inicial,
      data_final,
    };

    setDataFiltro(
      `de ${dataI.toLocaleDateString()} até ${dataF.toLocaleDateString()}`
    );
    const response = await getAllData(
      "controle-de-mensagens-clientes",
      objCons
    );

    setDados(response.data);
    setLoading(false);
  };

  useEffect(() => {
    getColumns();
  }, []);

  useEffect(() => {
    const date = new Date();
    const dateCorrect = getDateInitMonth(date);
    getDados(dateCorrect.data_inicial, dateCorrect.data_final);
  }, []);

  useEffect(() => {
    if (!filters.length) {
      setIndexList(10);
      setFilteredTable(false);
      return;
    }

    let testeFilters = {};

    filters.forEach((ele) => {
      // testeFilters[arguments[ele]]
      const param = Object.getOwnPropertyNames(ele)[0];
      testeFilters[param] = [];
    });

    filters.forEach((ele) => {
      // testeFilters[arguments[ele]]
      const param = Object.getOwnPropertyNames(ele)[0];
      // testeFilters[param].push(ele[param])
      testeFilters[param].push(String(ele[param]).toLowerCase());

      if (String(ele[param]).toLowerCase() == "false") {
        testeFilters[param].push("null");
      }
    });

    let arrayRetorno = [dados];

    Object.keys(testeFilters).forEach((key, index) => {
      arrayRetorno.push(
        filtroDinamicoArrays(
          testeFilters,
          key,
          arrayRetorno[arrayRetorno.length - 1]
        )
      );
    });

    const arrayF = removerDadosDuplicados(
      arrayRetorno[arrayRetorno.length - 1],
      "id"
    );
    setFilteredTable(arrayF.reverse());
  }, [filters]);

  useEffect(() => {
    const refTable = tableRef.current;
    const scrollHandler = (e) => {
      const tbodyHeight = tbodyRef.current.clientHeight;
      const divTableHeight = e.target.clientHeight;
      const scrollPosition = e.target.scrollTop;
      if (scrollPosition >= tbodyHeight - divTableHeight) {
        setTimeout(() => {
          setIndexList(indexList + 10);
        }, 1000);
      }
    };

    refTable.addEventListener("scroll", scrollHandler, false);

    return () => refTable.removeEventListener("scroll", scrollHandler, false);
  });

  const onClickRemoveFilter = (e) => {
    e.preventDefault();
    const value = e.target.parentNode.firstElementChild.innerText;
    const [key, keyValue] = value.split(":");
    setFilters((last) => [
      ...last.filter(
        (item) =>
          String(item[key]).replaceAll(" ", "") !== keyValue.replaceAll(" ", "")
      ),
    ]);
  };

  const [filtersNew, setFiltersNew] = useState({});

  //sistema de mensageria com o socket

  useEffect(() => {
    socket.on("atualizar_mensagens_clientes", (message) => {
      const items = dados.filter((item) => item.id != message.id);
      setDados(items);
    });

    return () => {
      socket.off("atualizar_mensagens_clientes");
    };
  }, [socket, dados]);

  return (
    <Fragment>
      <div className="section-filters-table mb-5">
        <div className="card-header">
          <h3>Filtros Selecionados</h3>
        </div>
        <Row className="mt-2 row-filters">
          <Col>
            <div>
              {filters.map((item, key) =>
                Object.keys(item).map((key, index) => {
                  return (
                    <span className="filters-card" key={index}>
                      <span className="filters">
                        <span className="title">
                          {key}: {item[key]}
                        </span>
                        <i
                          className="bi bi-x-lg"
                          onClick={onClickRemoveFilter}
                        ></i>
                      </span>
                    </span>
                  );
                })
              )}
            </div>
          </Col>
        </Row>
      </div>
      <div className="section-filters-table">
        <div className="card-header pb-2">
          <Row className="justify-content-between">
            <Col sm="12" md="6" lg="8">
              <h3 style={{ display: "flex", alignItems: "center" }}>
                Tabela de Dados{" "}
                {loading ? (
                  <Spinner
                    style={{ marginLeft: "10px", fontSize: "1rem" }}
                    animation="border"
                    size="sm"
                  />
                ) : (
                  ""
                )}
              </h3>
            </Col>

            <Col sm="12" md="6" lg="2">
              <ExportToExcel reference={dados} />
            </Col>
          </Row>
        </div>
        <div className=" responsive-table" ref={tableRef}>
          <ScrollbarLeft tableRef={tableRef} />
          <Table hover size="sm">
            <thead style={{ zIndex: 49 }}>
              <HeadTable
                arrayValues={dados}
                headerList={headList}
                setArrayFilters={setFiltersNew}
                arrayFilters={filtersNew}
                setFiltersOld={setFilters}
                filtersOld={filters}
                fn={getDados}
              />
            </thead>
            <tbody ref={tbodyRef}>
              {filteredTable
                ? filteredTable.map((item, index, self) => {
                    if (index < indexList) {
                      return (
                        <BodyRowLocal
                          key={index}
                          bodyList={item}
                          headList={headList}
                          index={index}
                          tableLength={self.length}
                          setDataTable={setDados}
                        />
                      );
                    }
                  })
                : [...dados].reverse().map((item, index, self) => {
                    if (index < indexList) {
                      return (
                        <BodyRowLocal
                          key={index}
                          bodyList={item}
                          headList={headList}
                          index={index}
                          tableLength={self.length}
                          setDataTable={setDados}
                        />
                      );
                    }
                  })}
            </tbody>
          </Table>
        </div>
      </div>
      {lancarModal.flag ? (
        <ModalLancamento
          show={lancarModal.flag}
          setShow={setLancarModal}
          title={"Lançar Novo Freteiro"}
          getData={getDados}
        />
      ) : (
        ""
      )}
    </Fragment>
  );
}

function BodyRowLocal({
  headList,
  bodyList,
  index,
  setDataTable = () => {},
  tableLength = 0,
}) {
  const refRow = useRef(null);
  const userS = useSelector((state) => state.userSlice);

  const [controleCancelamento, setControleCancelamento] = useState({
    falg: false,
  });
  const [controleEdicao, setControleEdicao] = useState({ falg: false });
  const [error, setError] = useState({
    show: false,
  });

  const getData = useCallback(async () => {
    const url = "controle-de-mensagens";
    try {
      const data = await getAllData(url);
      setDataTable(data.data);
    } catch (error) {
      setError({
        show: true,
        message: getErrorMessage(error),
      });
    }
  });

  const onClickCancelItem = async () => {
    setLoading(true);
    try {
        await updateTableNew(
            `controle-de-mensagens-clientes?id=${bodyList.id}`,
            bodyList
        );
        setLoading(false);
    } catch (error) {
      setLoading(false);
      setError({
        show: true,
        message: getErrorMessage(error),
      });
    }
  };

  const onClickEditar = async (bodyUpdate) => {
    const url = "controle-de-mensagens";
    await updateTable(url, bodyList.id, {
      ...bodyUpdate,
      manutencao_id: bodyList.manutencao_id,
    });
    getData(bodyList.manutencao_id);
  };

  const [loading, setLoading] = useState(false);

  const onClickTableRow = (e) => {
    e.preventDefault();
    refRow.current.classList = "bg-selected";
    let refRowNumber = refRow.current.children[0].innerText;

    let i = refRowNumber;
    let actualSibling = refRow.current.nextSibling;

    while (i < tableLength) {
      if (actualSibling === null) {
        break;
      }
      actualSibling.classList = "";

      actualSibling = actualSibling.nextSibling;
      i++;
    }

    i = refRow.current.children[0].innerText;
    actualSibling = refRow.current.previousSibling;
    while (0 < i) {
      if (actualSibling === null) {
        break;
      }
      actualSibling.classList = "";
      actualSibling = actualSibling.previousSibling;
      i--;
    }
    // setCargaSelecionada({
    //     ...bodyList
    //     , disponivel: bodyList.status === 0 ? true : false
    // })
  };

  return (
    <Fragment>
      {
        <tr
          ref={refRow}
          style={{ verticalAlign: "middle" }}
          onClick={onClickTableRow}
          
        >
          {headList.map((item, _index) => {
            if (item === "index") {
              return <td key={_index}> {index + 1}</td>;
            } else if (item === "admin") {
              return (
                <td key={_index}>
                  <div className="admin">
                    <span className="excluir">
                      {loading ? (
                        <Spinner animation="border" size="sm" key={`body-row-${bodyList.id}`}/>
                      ) : (
                        <i
                          className="bi bi-x-lg"
                          title="Excluir"
                          onClick={onClickCancelItem}
                        />
                      )}
                    </span>
                    <span className="editar">
                      <i
                        className="bi bi-pencil"
                        title="Editar"
                        // onClick={onClickEditarRow}
                      ></i>
                    </span>
                  </div>
                </td>
              );
            } else if (item === "status_carga") {
              return (
                <td key={_index} className={item}>
                  {bodyList[item] == "ENTREGUE AO CLIENTE" ? (
                    <div className="div-status">
                      <span className="div-status-ativo bg-success">
                        ENTREGUE AO CLIENTE
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                  {bodyList[item] == "SAIU PARA ENTREGA" ? (
                    <div className="div-status">
                      <span className="div-status-ativo bg-danger">
                        SAIU PARA ENTREGA
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                  {bodyList[item] == "DISPONIVEL PARA RETIRAR NA LOJA" ? (
                    <div className="div-status">
                      <span className="div-status-ativo bg-warning">
                        DISPONIVEL PARA RETIRAR NA LOJA
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                  {bodyList[item] == "DESCARREGADO NA LOJA" ? (
                    <div className="div-status">
                      <span className="div-status-ativo bg-warning">
                        DESCARREGADO NA LOJA
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                  {bodyList[item] == "CARREGADO" ? (
                    <div className="div-status">
                      <span className="div-status-ativo bg-warning">
                        CARREGADO
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                  {bodyList[item] == "SEPARADO" ? (
                    <div className="div-status">
                      <span className="div-status-ativo bg-info">SEPARADO</span>
                    </div>
                  ) : (
                    ""
                  )}
                  {bodyList[item] == "ENVIO DO ROMANEIO" ? (
                    <div className="div-status">
                      <span className="div-status-ativo bg-dark">
                        ENVIO DO ROMANEIO
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </td>
              );
            } else if (["enviado", "entregue", "lido"].includes(item)) {
              /* primary key can not be modified */
              return (
                <td key={_index} className={item}>
                  <div
                    className="div-status"
                    style={{
                      color: getColorOfStatusBool(bodyList[item] ? "1" : "0")
                        .color,
                      backgroundColor: getColorOfStatusBool(
                        bodyList[item] ? "1" : "0"
                      ).bgColor,
                      padding: "4px 6px",
                      borderRadius: "4px",
                      textAlign: "center",
                      boxShadow: "0 0 5px #0A061E80",
                      border: "1px solid #E2E3DF80",
                      width: "max-content",
                    }}
                  >
                    {bodyList[item] ? "SIM" : "NÃO"}
                  </div>
                </td>
              );
            } else if (
              [
                "emissao",
                "data_envio",
                "data_entrega",
                "data_leitura",
              ].includes(item)
            ) {
              /* primary key can not be modified */
              return (
                <td key={_index}>
                  {bodyList[item]
                    ? new Date(bodyList[item]).toLocaleString("pt-br")
                    : ""}
                </td>
              );
            } else if (item === "cliente") {
              return (
                <td key={_index} style={{ minWidth: "150px" }}>
                  {" "}
                  {bodyList[item]}
                </td>
              );
            } else if (item === "cpf_cnpj") {
              return (
                <td key={_index} style={{ minWidth: "150px" }}>
                  {" "}
                  {cpf_cnpj_mask(bodyList[item])}
                </td>
              );
            } else if (item === "telefone") {
              return (
                <td key={_index} style={{ minWidth: "150px" }}>
                  {" "}
                  {telefone_mask(bodyList[item])}
                </td>
              );
            }
            return (
              <td key={_index} className={item}>
                {" "}
                {bodyList[item]}
              </td>
            );
          })}
        </tr>
      }

      {controleCancelamento.flag ? (
        <ModalCancelamento
          {...controleCancelamento}
          setShow={setControleCancelamento}
        />
      ) : (
        ""
      )}
      {controleEdicao.flag ? (
        <ModalEdicao {...controleEdicao} setShow={setControleEdicao} />
      ) : (
        ""
      )}
      {error.show ? <ModalErrorPretty {...error} setShow={setError} /> : ""}
    </Fragment>
  );
}
